export default "__VITE_ASSET__fdabc657__"